module.exports = __webpack_public_path__ + "media/SOC/cut-off-date-7a231914.svg";